export default __webpack_public_path__ + "static/media/property_45.e677f22a.png";